import { render, staticRenderFns } from "./course-modal.vue?vue&type=template&id=ac73d5fe"
import script from "./course-modal.vue?vue&type=script&lang=js"
export * from "./course-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports